import { palette } from '@shipium-corp/shipium-ui-theme';

export const colorMap = [
  palette.Fuschia.normal,
  palette.Blue.normal,
  palette.Gold.normal,
  palette.Coral.normal,
  palette.Violet.normal,
  palette.Teal.normal,
  palette.Blue.dark,
  palette.Coral.dark,
  palette.Fuschia.dark,
  palette.Gold.dark,
  palette.Teal.dark,
  palette.Violet.dark,
];

export const fillColorMap = [
  palette.Fuschia.normal,
  palette.Blue.normal,
  palette.Gold.normal,
  palette.Coral.normal,
  palette.Blue.light,
  palette.Coral.normal,
  palette.Violet.dark,
];

export const carrierColorMap = new Map([
  ['usps', '001B87'],
  ['ups', '732D02'],
  ['fedex', 'FF5E3F'],
  ['ontrac', 'FFC300'],
  ['cdl', '692659'],
]);

export const markerForIndex = (index: number) => {
  const color = index < 12 ? colorMap[index] : palette.Blue.dark;
  const markerSVG = `<svg stroke="black" fill="currentColor" stroke-width="10" viewBox="0 0 384 512" color="${color}" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>`;
  const iconUrl = encodeURI('data:image/svg+xml,' + markerSVG).replace('#', '%23');
  return iconUrl;
};
